import { deviceInterceptor } from './device/device.interceptor';
import { errorInterceptor } from './error/error.interceptor';
import { tokenInterceptor } from './token/token.interceptor';
import { tokenEchoInterceptor } from './token-echo/token-echo.interceptor';
import { tokenRefreshInterceptor } from './token-refresh/token-refresh.interceptor';
import { versionInterceptor } from './version/version.interceptor';

// Orders matter
export const httpInterceptorProviders = [
  deviceInterceptor,
  errorInterceptor,
  tokenEchoInterceptor,
  tokenInterceptor,
  tokenRefreshInterceptor,
  versionInterceptor
];
